import "dayjs/locale/en"
import dayjs from "dayjs"

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider as Provider } from "@mui/x-date-pickers/LocalizationProvider"

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode
}

export function LocalizationProvider({ children }: Props) {
    dayjs.locale("en")

    return (
        <Provider dateAdapter={AdapterDayjs} adapterLocale="en">
            {children}
        </Provider>
    )
}
